import API from '@/api';

class Main
{

  /**
   * Do api call on specified method and endpoint to get list of countries
   *
   * @param {bool} isIso Determine if this should be our ISO compliant countries
   *
   * @return {promise}
   */
  static async getCountries(isIso = false) {

    const params = (isIso)
          ? { isIso: true }
          : { detailed: true }

    return await API.dispatch(
      'GET',
      'countries',
      { query: params }
    );
  }

  /**
   * Create payment intent for the donation
   *
   * @return {promise}
   */
  static async createPaymentIntent(payload) {
    return await API.dispatch(
      'POST',
      'payment',
      {
        data: payload
      }
    );
  }

  /**
   * Gets tenant publishable key
   *
   * @return {promise}
   */
  static async getPublishableKey(paymentGatewayType) {
    return await API.dispatch(
      'GET',
      'paymentGatewayKey',
      {
        path: {
          payment_gateway_type: paymentGatewayType
        }
      }
    );
  }

  /**
   * Create the question answers for this specific donation
   *
   * @param String missionId
   * @param String paymentId
   * @param Object answers
   *
   * @param {promise}
   */
  static async createQuestionAnswers(missionId, paymentId, answers) {
    return await API.dispatch(
      'POST',
      'questionAnswers',
      {
        data: {
          mission_id: missionId,
          payment_id: paymentId,
          answers: answers
        }
      }
    )
  }

  /**
   * Download donation pdf receipt
   *
   * @param String donationId
   *
   * @param {promise}
   */
  static async downloadReceipt(donationId) {
    return await API.dispatch(
      'GET',
      'downloadReceipt',
      {
        path: {
          id: donationId
        }
      }
    );
  }

  /**
   * Check if the amount is fraudulent
   *
   * @return {promise}
   */
  static async verifyAmount(payload) {
    return await API.dispatch(
      'POST',
      'verifyAmount',
      {
        data: payload
      }
    );
  }
}

export default Main;
